export default __webpack_public_path__ + "static/media/upload-duotone.56ed1d1e.svg";